import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Typography, message, Spin, Image, Button } from "antd";
import { ROW_JUSTIFY, COL_SPAN, ENTER_ORG_TYPE } from "../common/const";
import { useIntl } from "react-intl";
import {
  UrlQueryParamsParse,
  OpenBrowserUrl,
  getRedirectUrl,
  CheckSystem,
  getUrlParam,
  addUrlParam,
  openRedirectUrl,
} from "../common/globalFun";
import API from "../config/api";
import { PostTeamCreate, PostTeamJoin } from "../config/request";
import { GetErrMsg } from "../config/errCode";
import { LoadingOutlined, ArrowRightOutlined } from "@ant-design/icons";

import HeaderLogo from "../components/HeaderLogo";
import PageBg from "../components/PageBg";
import SelectOptions from "../components/SelectOptions";
import PageHeaderComponents from "../components/PageHeader";
import signorgBgImg from "../res/img/signorg_bg.png";

import "./css/style.css";

const { Title } = Typography;

const SigninOrg = (props) => {
  const { history } = props;
  const intl = useIntl();

  const [loading, setLoading] = useState(false);
  const [isFromClient, setIsFromClient] = useState(false);
  const [comeBackDisabled, setComeBackDisabled] = useState(false);

  const goToCreateTeamPage = (type) => {
    if (loading || props.redirecting) {
      console.log("Error: is init token loading");
      return;
    }
    let urlParam = {
      enterOrgType: type,
      isFromClient: isFromClient,
    };
    console.log("push create team", urlParam);

    history.push({ pathname: "/create_team", data: urlParam });
  };

  const getUrlToken = () => {
    return new Promise((resolve, reject) => {
      const { search } = props.location;
      const urlQuertParamsStr = search.replace(/^\?/, "");
      const queryParamsData = UrlQueryParamsParse(urlQuertParamsStr);
      if (queryParamsData && queryParamsData.token) {
        const identifyToken = decodeURIComponent(queryParamsData.token);
        resolve(identifyToken);
      } else {
        reject("");
      }
    });
  };

  // 身份验证token 转成 JWT token
  const getToken = (token) => {
    setLoading(true);

    const url = API.GET_TOKEN;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        timestamp: new Date().getTime().toString(),
        token: token,
      }),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.errCode == "0000") {
          const { token, userInfo } = rsp;
          props.setGlobalToken(token);
          if (userInfo.account) {
            props.setGlobalEmail(userInfo.account);
          }
        } else {
          message.error(GetErrMsg(rsp.errCode));
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const autoCreateTeam = async () => {
    setLoading(true);

    let name = props.email;
    if (props.account) {
      name = props.account;
    }

    PostTeamCreate({
      account: props.email,
      teamName: intl.formatMessage({ id: "org.of.the.name" }, { name: name }),
      username: name,
    })
      .then((rsp) => {
        if (rsp) {
          props.setGlobalCorpName(name);
          if (rsp.info) {
            const { corpId, reloginKey } = rsp.info;
            props.setGlobalCorpId(corpId);
            props.setGlobalLoginKey(reloginKey);
          }
          if (rsp.certificate) {
            const { team } = rsp.certificate;
            props.setGlobalCorpId(team.team_id);
          }
          if (props.quickRegister) {
            const redirectUrl = getRedirectUrl();
            window.location.href = `${redirectUrl}?isRegister=true`;
          } else {
            history.push("/invite");
          }
        } else {
          OpenBrowserUrl(getRedirectUrl());
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const autoJoinOrg = () => {
    setLoading(true);

    PostTeamJoin({
      account: props.email,
      invite_code: props.inviteCode,
    })
      .then((rsp) => {
        if (CheckSystem.Felo()) {
          const { loginKey, login_key } = rsp;
          props.setGlobalLoginKey(loginKey || login_key);
          history.push("/download");
        } else {
          OpenBrowserUrl(getRedirectUrl());
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUrlToken()
      .then((identifyToken) => {
        setIsFromClient(true);
        if (!props.token) {
          getToken(identifyToken);
        }
      })
      .catch(() => {
        console.log("not get url token");
      });
  }, []);

  useEffect(() => {
    const { data } = props.location;
    if (data && data.comeBackDisabled) {
      setComeBackDisabled(true);
    }
  }, []);

  useEffect(() => {
    if (props.quickRegister) {
      autoCreateTeam();
    }
    if (props.inviteCode) {
      autoJoinOrg();
    }
  }, []);

  useEffect(() => {
    if (props.redirecting) {
      message.loading({
        content: "Redirecting..",
        duration: 0,
        style: {
          marginTop: "10vh",
        },
      });
    }
  }, [props.redirecting]);

  const SelectOrgOptionsArr = [
    {
      title: intl.formatMessage({ id: "title.join.new.org" }),
      desc: intl.formatMessage({ id: "desc.join.new.org" }),
      type: ENTER_ORG_TYPE.JOINCODE,
    },
    {
      title: intl.formatMessage({ id: "title.create.new.org" }),
      desc: intl.formatMessage({ id: "desc.create.new.org" }),
      type: ENTER_ORG_TYPE.CREATE,
    },
  ];

  /**
   * Dom
   */

  const loadingIcon = () => (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
  );

  return (
    <>
      {props.inviteCode ? (
        <Title
          level={3}
          className="no-margin-top content-center felx-center"
        ></Title>
      ) : (
        <>
          {!comeBackDisabled && (
            <PageHeaderComponents
              className={["page-header", isFromClient ? "hide" : ""]}
              disabled={comeBackDisabled}
              title=" "
            />
          )}

          {!isFromClient && <PageBg />}
          <Row justify={ROW_JUSTIFY} align="middle" className={`height-full`}>
            <Col span={COL_SPAN}>
              {props.quickRegister ? (
                <Title level={3} className="no-margin-top content-center">
                  {loadingIcon()}
                </Title>
              ) : (
                <section
                  className={`hd-section createTeamHead`}
                  hidden={isFromClient}
                >
                  <HeaderLogo />
                  <Title level={2}>
                    {intl.formatMessage({ id: "create.team.title" })}
                  </Title>
                </section>
              )}

              <section
                className={`${isFromClient ? "select-enter-org-wrap" : ""}`}
                hidden={props.quickRegister}
              >
                <section
                  hidden={!isFromClient}
                  className={`signin-org-bg-wrap`}
                >
                  <Image width={360} src={signorgBgImg} preview={false} />
                </section>

                <section>
                  {SelectOrgOptionsArr.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`${index != 0 ? "mt-24" : ""}`}
                      >
                        <Spin
                          spinning={loading}
                          indicator={
                            <LoadingOutlined style={{ fontSize: 24 }} spin />
                          }
                        >
                          <SelectOptions
                            className={`enter-org-option`}
                            title={item.title}
                            desc={item.desc}
                            onClick={() => {
                              goToCreateTeamPage(item.type);
                            }}
                          />
                        </Spin>
                      </div>
                    );
                  })}
                </section>

                <section
                  className={`mt-50 content-center`}
                  hidden={isFromClient}
                  style={{ display: "none" }}
                >
                  <Button
                    type="primary"
                    size="large"
                    style={{ minWidth: 100 }}
                    onClick={autoCreateTeam}
                    disabled={loading}
                  >
                    {intl.formatMessage({ id: "skip" })}
                    <ArrowRightOutlined />
                  </Button>
                </section>
              </section>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

const stateProps = (state) => {
  return {
    email: state.email,
    account: state.account,
    token: state.token,
    quickRegister: state.quickRegister,
    inviteCode: state.inviteCode,
    redirecting: state.redirecting,
  };
};

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: "setToken",
      value: token,
    });
  },
  setGlobalEmail: (email) => {
    dispatch({
      type: "setEmail",
      value: email,
    });
  },
  setGlobalLoginKey: (key) => {
    dispatch({
      type: "setLoginKey",
      value: key,
    });
  },
  setGlobalCorpId: (id) => {
    dispatch({
      type: "setCorpId",
      value: id,
    });
  },
  setGlobalCorpName: (name) => {
    dispatch({
      type: "setCorpName",
      value: name,
    });
  },
});

export default connect(stateProps, dispatchProps)(SigninOrg);
